import MojitoCore from 'mojito/core';
import ActiveBonuses from './view/index.js';
import MojitoServices from 'mojito/services';
import { connect } from 'react-redux';

const { actions: userBonusesActions, selectors: userBonusesSelectors } = MojitoServices.UserBonuses;
const { selectors: campaignSelectors, actions: campaignActions } = MojitoServices.BonusCampaign;
const { selectActiveFreeBets, selectActiveOddsBoosts, selectIsFetchingActive } =
    userBonusesSelectors;
const { selectCurrency } = MojitoServices.UserInfo.selectors;
const { UIViewImplementation } = MojitoCore.Presentation;
const { selectActiveBonusCampaigns, selectCampaignsPending } = campaignSelectors;
const { BONUS_FILTER } = MojitoServices.Bonus.types;

class ActiveBonusesController extends UIViewImplementation {
    componentDidMount() {
        this.props.showPrewager &&
            this.props.dispatch(campaignActions.getCampaigns(BONUS_FILTER.ACTIVE));
        this.props.dispatch(userBonusesActions.fetchActiveUserBonuses());

        const hasBonuses = this.hasBonuses();
        // Content is already loaded and we can't guarantee that componentDidUpdate will be called.
        if (hasBonuses) {
            this.props.onContentLoad(true);
        }
    }

    componentDidUpdate() {
        if (!this.isLoading() || this.hasBonuses()) {
            this.props.onContentLoad(this.hasBonuses());
        }
    }

    isLoading() {
        const { isLoadingCampaigns, isLoadingBonuses } = this.props;
        return isLoadingCampaigns && isLoadingBonuses;
    }

    hasBonuses() {
        const { showPrewager, showOddsBoosts, campaigns, oddsBoosts, freeBets } = this.props;
        const hasCampaigns = showPrewager && !!campaigns.length;
        const hasOddsBoosts = showOddsBoosts && !!oddsBoosts.length;
        const hasFreeBets = !!freeBets.length;
        return hasCampaigns || hasOddsBoosts || hasFreeBets;
    }

    render() {
        return (
            <ActiveBonuses
                campaigns={this.props.campaigns}
                freeBets={this.props.freeBets}
                oddsBoosts={this.props.oddsBoosts}
                currencyCode={this.props.currencyCode}
                config={this.config.view}
                showPrewager={this.props.showPrewager}
                showOddsBoosts={this.props.showOddsBoosts}
                isLoading={this.isLoading()}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const campaignsPending = selectCampaignsPending(state);
    const campaigns = selectActiveBonusCampaigns(state);
    const isLoadingCampaigns = ownProps.showPrewager
        ? campaignsPending && !campaigns.length
        : false;

    const freeBets = selectActiveFreeBets(state);
    const oddsBoosts = selectActiveOddsBoosts(state);
    const hasBonuses = !!freeBets.length || !!oddsBoosts.length;
    const isLoadingActiveBonuses = selectIsFetchingActive(state);
    const isLoadingBonuses = isLoadingActiveBonuses && !hasBonuses;

    return {
        isLoadingCampaigns: isLoadingCampaigns,
        isLoadingBonuses: isLoadingBonuses,
        freeBets: freeBets,
        oddsBoosts: oddsBoosts,
        campaigns: campaigns,
        currencyCode: selectCurrency(state),
    };
};

export default connect(mapStateToProps)(ActiveBonusesController);
